import {DependencyList} from 'react';
import {EffectCallback} from 'react';
import {useEffect, useRef} from 'react';

const useUpdateEffect = (effect: EffectCallback, deps?: DependencyList): void => {
	const isMounted = useRef(false);

	useEffect(() => {
		if (isMounted.current) {
			return effect();
		} else {
			isMounted.current = true;
		}
	}, deps);
};

export default useUpdateEffect;
